export default "__VITE_ASSET__CaPf77LM__"